export const normalizeCategoryDescription = (countryCode: string, description: string): string => {
  if (!description) {
    return description;
  }

  return description.replace(/href=[\'"]\//gm, `href="/${countryCode}/`);
};
